import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d2a5fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "evaluate"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-star-light" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 3,
  class: "textLink"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 5,
  class: "msg-house"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "house-img"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://szimg.xhj.com/xhj/images/2023-08-25/dad285f6-bbef-417e-b2c5-7d0a142edfde.png",
  "lazy-load": ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "info"
}
const _hoisted_19 = { class: "title" }
const _hoisted_20 = {
  key: 0,
  class: "info_shuju"
}
const _hoisted_21 = {
  key: 0,
  class: "other_other"
}
const _hoisted_22 = { class: "price" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "avgPrice"
}
const _hoisted_26 = {
  key: 1,
  class: "new-house-price"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元/m²", -1))
const _hoisted_28 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCustom === _ctx.constant.typeService)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.extension.title), 1),
            (_ctx.extension.hyperlinks_text)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.extension.hyperlinks_text.value,
                  target: "view_window"
                }, _toDisplayString(_ctx.extension.hyperlinks_text.key), 9, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (_ctx.extension.item && _ctx.extension.item.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extension.item, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    (_ctx.isUrl(item.value))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: item.value,
                          target: "view_window"
                        }, _toDisplayString(item.key), 9, _hoisted_5))
                      : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.key), 1))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("article", null, _toDisplayString(_ctx.extension.description), 1)
        ]))
      : (_ctx.isCustom.businessID === _ctx.constant.typeEvaluate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("message.custom.对本次服务评价")), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(~~_ctx.isCustom.score, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "evaluate-list-item",
                  key: index
                }, _hoisted_9))
              }), 128))
            ]),
            _createElementVNode("article", null, _toDisplayString(_ctx.isCustom.comment), 1)
          ]))
        : (_ctx.isCustom.businessID === _ctx.constant.typeOrder)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "order",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.isCustom.link)))
            }, [
              _createElementVNode("img", {
                src: _ctx.isCustom.imageUrl,
                alt: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("main", null, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.isCustom.title), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.isCustom.description), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.isCustom.price), 1)
              ])
            ]))
          : (_ctx.isCustom.businessID === _ctx.constant.typeTextLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", null, _toDisplayString(_ctx.isCustom.text), 1),
                _createElementVNode("a", {
                  href: _ctx.isCustom.link,
                  target: "view_window"
                }, _toDisplayString(_ctx.$t("message.custom.查看详情>>")), 9, _hoisted_12)
              ]))
            : (_ctx.isCustom.businessID === _ctx.constant.TYPE_CALL_MESSAGE)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["call", `call-${_ctx.data?.message?.conversationType}`]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCallAgain && _ctx.handleCallAgain(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon", _ctx.handleCallMessageIcon()])
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.custom), 1)
                ], 2))
              : (_ctx.data.message.cloudCustomData === _ctx.constant.TYPE_MESSAGE_HOUSE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_ctx.houseData.img)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.houseData.img,
                          "lazy-load": ""
                        }, null, 8, _hoisted_14))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)),
                    true
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.houseData.title), 1),
                          (_ctx.houseData.housetype != '1' && _ctx.houseData.housetype != '13')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_ctx.houseData.other)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.houseData.other.roomNumber || "-") + "室" + _toDisplayString(_ctx.houseData.other.hallNumber || "-") + "厅/" + _toDisplayString(_ctx.houseData.other.area || "") + "m² ", 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_22, [
                                  _createTextVNode(_toDisplayString(_ctx.houseData.price) + " ", 1),
                                  (_ctx.houseData.housetype == 12)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "元"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_24, "万")),
                                  (_ctx.houseData.avgPrice)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(" + _toDisplayString(_ctx.houseData.avgPrice) + "元/m²)", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.houseData.price), 1),
                                  _hoisted_27
                                ])
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, "暂不支持该信息类型，请前往APP查看"))
  ]))
}